var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionInfo05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 9,
    fill: "#F5F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3349 21.5021L21.5049 21.5026C23.9902 21.5026 26.0049 23.5173 26.0049 26.0026L19.0039 26.0017L19.0049 27.0026L27.0049 27.0018V26.0026C27.0049 24.9201 26.6867 23.8995 26.1188 23.0018L29.0049 23.0026C30.9972 23.0026 32.7173 24.1678 33.521 25.854C31.1562 28.9746 27.3268 31.0026 23.0049 31.0026C20.2436 31.0026 17.9044 30.412 16.0045 29.3778L16.0059 20.0736C17.2515 20.252 18.3912 20.7582 19.3349 21.5021ZM14.0049 19.0026C14.5177 19.0026 14.9404 19.3886 14.9982 19.8859L15.0049 20.0017V29.0026C15.0049 29.5549 14.5572 30.0026 14.0049 30.0026H12.0049C11.4526 30.0026 11.0049 29.5549 11.0049 29.0026V20.0026C11.0049 19.4503 11.4526 19.0026 12.0049 19.0026H14.0049ZM23.6513 13.5779L24.0046 13.9317L24.3584 13.5779C25.3347 12.6016 26.9177 12.6016 27.894 13.5779C28.8703 14.5542 28.8703 16.1372 27.894 17.1135L24.0049 21.0026L20.1158 17.1135C19.1395 16.1372 19.1395 14.5542 20.1158 13.5779C21.0921 12.6016 22.675 12.6016 23.6513 13.5779Z",
    fill: "url(#paint0_linear_1788_10330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1788_10330",
    x1: 9.25213,
    y1: 5.72536,
    x2: 60.1132,
    y2: 12.5112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F3AFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionInfo05);
export default __webpack_public_path__ + "static/media/subscription_info05.df9a252cd89e9aa590a914f317911765.svg";
export { ForwardRef as ReactComponent };